export default class Logger {
  static log = (() => {
    if (!__DEV__) return () => {};
    return Function.prototype.bind.call(console.log, console, '## LOGGER: ');
  })();
}
